// Subtle animated side-profile walker for the capture hero. Legs and arms swing
// in anti-phase about hip/shoulder with a gentle body bob — a one-stride loop.
// Purely decorative; respects prefers-reduced-motion via CSS.

export function GaitSilhouette({ size = 96 }: { size?: number }) {
  return (
    <svg
      className="gait-silhouette"
      width={size}
      height={size}
      viewBox="0 0 120 120"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="gsg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7cc4ff" />
          <stop offset="100%" stopColor="#5eead4" />
        </linearGradient>
      </defs>
      <g className="gs-body">
        {/* back leg + back arm (drawn first, dimmer) */}
        <g className="gs-leg gs-b" stroke="rgba(124,196,255,0.45)" strokeWidth={7} strokeLinecap="round" strokeLinejoin="round" fill="none">
          <polyline points="60,66 59,90 60,112" />
          <line x1="60" y1="112" x2="69" y2="112" />
        </g>
        <g className="gs-arm gs-armB" stroke="rgba(124,196,255,0.4)" strokeWidth={5} strokeLinecap="round" fill="none">
          <line x1="60" y1="34" x2="60" y2="54" />
        </g>
        {/* torso + head */}
        <g stroke="url(#gsg)" strokeWidth={8} strokeLinecap="round" fill="none">
          <line x1="60" y1="34" x2="60" y2="66" />
        </g>
        <circle cx="60" cy="22" r="9" fill="url(#gsg)" />
        {/* front leg + front arm (brighter) */}
        <g className="gs-leg gs-f" stroke="url(#gsg)" strokeWidth={7} strokeLinecap="round" strokeLinejoin="round" fill="none">
          <polyline points="60,66 61,90 60,112" />
          <line x1="60" y1="112" x2="69" y2="112" />
        </g>
        <g className="gs-arm gs-armF" stroke="url(#gsg)" strokeWidth={5} strokeLinecap="round" fill="none">
          <line x1="60" y1="34" x2="60" y2="54" />
        </g>
      </g>
    </svg>
  );
}
